<template>
  <div class="md-card md-card-global-sales">
    <div class="md-card-header md-card-header-icon" :class="getClass(headerColor)">
      <slot name="header"></slot>
    </div>

    <div class="md-card-content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "global-sales-card",
  props: {
    headerColor: {
      type: String,
      default: "",
    },
  },
  methods: {
    getClass: function (headerColor) {
      return "md-card-header-" + headerColor + "";
    },
  },
};
</script>

<style lang="css"></style>
